import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BottomSheetContentLayout, IconButton, Menu, useOverlayContext } from 'seagull';
import { DocumentCheckmark24, ChevronRight24, Plus, UserAddLiner24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { ManageContactModalForVendor } from '~/components/ManageContactModal/ManageContactModalForVendor';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { useOpenNewProposal } from '~/hooks/useOpenNewProposal';
import { withDeviceProvider } from '~/providers/DeviceProvider';
export var ItemId = /*#__PURE__*/ function(ItemId) {
    ItemId["CreateContact"] = "create-contact";
    ItemId["CreateProposal"] = "create-proposal";
    return ItemId;
}({});
export const getQuickActionsMenuTID = ()=>getTestIds();
function ActualQuickActionsMenu() {
    const { QuickActionsMenuTID } = useMemo(()=>getQuickActionsMenuTID(), []);
    const { refresh: refreshContacts } = useContacts({
        refreshOnMount: true
    });
    const { showBottomSheet, hideBottomSheet, pushBottomSheetPage, popBottomSheetPage } = useOverlayContext();
    const { isLoadingProposalTemplates, openNewProposal } = useOpenNewProposal();
    function handleClick() {
        const items = [
            {
                id: "create-contact",
                body: 'Create contact',
                prefixIcon: /*#__PURE__*/ _jsx(UserAddLiner24, {}),
                onClick: ()=>{
                    pushBottomSheetPage({
                        content: /*#__PURE__*/ _jsx(ManageContactModalForVendor, {
                            testId: "manage-contact-modal",
                            onClose: (savedContact)=>{
                                refreshContacts();
                                savedContact ? hideBottomSheet() : popBottomSheetPage();
                            },
                            origin: "Quick actions menu"
                        })
                    });
                }
            },
            {
                id: "create-proposal",
                body: 'Create proposal',
                disabled: isLoadingProposalTemplates,
                prefixIcon: /*#__PURE__*/ _jsx(DocumentCheckmark24, {}),
                onClick: ()=>openNewProposal()
            }
        ].map((item)=>_object_spread_props(_object_spread({}, item), {
                testId: QuickActionsMenuTID.Item(item.id),
                suffixIcon: /*#__PURE__*/ _jsx(ChevronRight24, {})
            }));
        showBottomSheet({
            content: /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
                header: {
                    title: 'Quick actions'
                },
                children: /*#__PURE__*/ _jsx(Menu, {
                    dimensions: {
                        width: 'auto'
                    },
                    items: items
                })
            })
        });
    }
    return /*#__PURE__*/ _jsx(IconButton, {
        skin: "primaryBoxed",
        size: "smallMedium",
        testId: QuickActionsMenuTID.Button(),
        onClick: handleClick,
        children: /*#__PURE__*/ _jsx(Plus, {
            height: 16,
            width: 16
        })
    });
}
export const QuickActionsMenu = withDeviceProvider(ActualQuickActionsMenu);
